<script lang="ts" context="module">
  export const matchingProps = [];
</script>

<script lang="ts">
  import _ from 'lodash';
  import AdminGridWithDetail from '../admin/AdminGridWithDetail.svelte';
  import TableControl from '../elements/TableControl.svelte';
  import Link from '../elements/Link.svelte';
  import TabControl from '../elements/TabControl.svelte';
  import FormTextField from '../forms/FormTextField.svelte';
  import FormPasswordField from '../forms/FormPasswordField.svelte';
  import FormCheckboxField from '../forms/FormCheckboxField.svelte';
  import PermissionsChooser2 from '../admin/PermissionsChooser.svelte';
  import RolesChooser from '../admin/RolesChooser.svelte';
  import AdminConnectionsGrid from '../admin/AdminConnectionsGrid.svelte';
  import { apiCall } from '../utility/api';
  import { showModal } from '../modals/modalTools';
  import ConfirmModal from '../modals/ConfirmModal.svelte';
  import { writable } from 'svelte/store';

  export let tabid;

  const filters = writable({});
</script>

<AdminGridWithDetail
  {tabid}
  requiredPermission="admin/users"
  adminLabel="Users"
  apiCallList="storage/get-user-list"
  apiCallGetDetail="storage/get-user-detail"
  apiCallSaveDetail="storage/save-user-detail"
  newObjectLabel="New user"
  pureTableName="users"
  labelField="login"
>
  <svelte:fragment slot="table" let:rows let:onSetSelectedObject let:onRefresh>
    <TableControl
      stickyHeader
      columns={[
        { header: 'ID', fieldName: 'id', sortable: true, filterable: true },
        { header: 'Login', fieldName: 'login', sortable: true, filterable: true },
        { header: 'E-mail', fieldName: 'email', sortable: true, filterable: true },
        { header: 'Password', fieldName: 'password', sortable: true },
        { header: 'Roles', fieldName: 'roles', slot: 1 },
        {
          header: 'Permissions',
          fieldName: 'permissions',
          slot: 2,
          filteredExpression: row => row.usedPermissions?.join(' '),
          filterable: true,
        },
        {
          fieldName: 'actions',
          header: '',
          slot: 3,
        },
      ]}
      clickable
      {filters}
      {rows}
      on:clickrow={e => {
        onSetSelectedObject(e.detail.id);
      }}
    >
      <svelte:fragment slot="3" let:row
        ><Link
          onClick={async e => {
            e.stopPropagation();
            showModal(ConfirmModal, {
              header: 'Delete user',
              message: `Are you sure you want to delete user "${row.login}"?`,
              confirmLabel: 'Delete',
              onConfirm: async () => {
                await apiCall('storage/delete-user', { id: row.id });
                onRefresh();
              },
            });
          }}>Remove</Link
        ></svelte:fragment
      >
      <svelte:fragment slot="1" let:row>{row.usedRoles?.join(', ')}</svelte:fragment>
      <svelte:fragment slot="2" let:row>{row.usedPermissions?.join(', ')}</svelte:fragment>
    </TableControl>
  </svelte:fragment>

  <svelte:fragment slot="detail" let:values>
    <TabControl
      tabs={[
        { label: 'Info', slot: 1 },
        { label: 'Connections', slot: 2 },
      ]}
      inlineTabs
    >
      <svelte:fragment slot="1">
        <div class="details-tab">
          <div class="col-4 flexcol m-2">
            <h4>Credentials</h4>
            <FormTextField label="Login" name="login" templateProps={{ noMargin: true }} autocomplete="off" />
            <div class="m-2" />
            <FormPasswordField
              label="Password"
              name="password"
              saveOnInput
              autocomplete="off"
              templateProps={{ noMargin: true }}
              placeholder={values?.password?.startsWith('crypt:') ? '(Password is encrypted)' : undefined}
            />
            <div class="m-2" />
            <FormCheckboxField label="Encrypt password" name="encryptPassword" templateProps={{ noMargin: true }} />
            <h4>Details</h4>
            <FormTextField label="E-mail" name="email" autocomplete="off" templateProps={{ noMargin: true }} />
          </div>
          <div class="col-4 flex1 flexcol m-2">
            <h4>Permissions</h4>
            <div class="flex1 bg-0 scroll">
              <PermissionsChooser2 />
            </div>
          </div>
          <div class="col-4 flex1 flexcol m-2">
            <h4>Roles</h4>
            <div class="flex1 bg-0 scroll">
              <RolesChooser />
            </div>
          </div>
        </div>
      </svelte:fragment>
      <svelte:fragment slot="2">
        <AdminConnectionsGrid />
      </svelte:fragment>
    </TabControl>
  </svelte:fragment>
</AdminGridWithDetail>

<style>
  .details-tab {
    display: flex;
    flex: 1;
  }

  h4 {
    text-transform: uppercase;
    font-weight: normal;
    color: var(--theme-font-2);
  }
</style>
